




































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import BpcDatePicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import moment from 'moment';
import BpcTable from '@shared/components/tables/table.vue';
import { POSActivitySession } from '@pos/interfaces/pos-v2';

@Component({
  name: 'bpc-pos-product-session-list',
  components: {
    BpcDatePicker,
    BpcTable,
  },
})
export default class PosProductSessionList extends Vue {
  // PROPS
  @Prop({ type: Number, required: true }) readonly posSessionId: number;
  @Prop({ type: Number }) readonly contactId!: number;
  @Prop({ type: Number }) readonly activitySessionReloadKey!: number;
  @Prop({ type: Boolean, default: true }) readonly readOnlyTicket: boolean;
  @Prop({ type: Boolean, default: false }) readonly changingTicket: boolean;

  // DATA
  search = '';
  selectedDate = moment().format('YYYY-MM-DD');
  loadingSessions = false;
  sessions: POSActivitySession[] = [];
  filteredSessions: POSActivitySession[] = [];
  sessionFieldsToShowInTable = [
    {
      key: 'formatedTimeRange',
      headerLabel: 'activities.activity_session_time_range_header_label',
    },
    { key: 'name', headerLabel: 'activities.activity_session_name_header_label' },
    { key: 'ocupation', headerLabel: 'activities.activity_session_ocupation_header_label' },
    {
      key: 'availability',
      headerLabel: 'activities.activity_session_availability_header_label',
    },
    {
      key: 'actions',
      headerLabel: '',
      class: '',
      help: '',
      thStyle: { width: '30%' },
      tdStyle: { width: '30%' },
    },
  ];
  // COMPUTED
  // LIFE CYCLE HOOKS
  mounted() {
    this.getSessions();
  }
  // METHODS
  async searchInSessions() {
    this.filteredSessions = !this.search
      ? this.sessions
      : this.sessions.filter(session => {
          const searchFields = [session.name];
          const searchFieldsString = searchFields.join(' ').toLowerCase();
          return searchFieldsString.includes(this.search.toLowerCase());
        });
  }

  clearSearch() {
    this.search = '';
  }

  async getSessions() {
    if (!this.contactId) {
      return;
    }
    this.loadingSessions = true;
    const res = await this.$posService.getActivitySessions(
      this.posSessionId,
      this.selectedDate,
      this.contactId,
    );
    console.log(res);
    this.sessions = res;
    this.searchInSessions();
    this.loadingSessions = false;
  }

  getSessionsIfStopChanging() {
    const currentDate = this.selectedDate;
    setTimeout(() => {
      if (currentDate === this.selectedDate) this.getSessions();
    }, 300);
  }

  formatOcupation(session: POSActivitySession) {
    if (!session.maxParticipants) {
      return `${session.numAttendees || 0}/${this.$t('activities.max_participants_unlimited')}`;
    }

    return `${session.numAttendees || 0}/${session.maxParticipants}`;
  }
  formatAvailability(session: POSActivitySession) {
    if (!session.maxParticipants) {
      return this.$t('activities.max_participants_unlimited');
    }
    const sessionAvailability = session.maxParticipants - (session.numAttendees || 0);
    return sessionAvailability > 0 ? sessionAvailability : 0;
  }
  async addAttendee(session: POSActivitySession) {
    this.$emit('add-attendee', session);
    // const res = await this.$posService.addAttendeeToActivitySession(this.posSessionId, session.id);
    // console.log(res);
  }

  // WATCHERS
  @Watch('selectedDate')
  onSelectedDateChanged() {
    this.getSessionsIfStopChanging();
  }
  @Watch('contactId')
  onContactIdChanged() {
    this.getSessions();
  }
  @Watch('activitySessionReloadKey')
  onactivitySessionReloadKeyChanged() {
    this.getSessions();
  }
  @Watch('search')
  onSearchChanged() {
    this.searchInSessions();
  }
}
